<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card type="chart">
          <template slot="header">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <el-select
                  v-model="dateSelection.month"
                  class="select-primary"
                  size="large"
                  placeholder="Month"
                  tabindex="4"
                >
                  <el-option
                    v-for="opt in dateOptions.month"
                    :key="opt"
                    :label="opt"
                    :value="opt"
                  />
                </el-select>

                <el-select
                  v-model="dateSelection.year"
                  class="select-primary"
                  size="large"
                  placeholder="Year"
                  tabindex="5"
                >
                  <el-option
                    v-for="opt in dateOptions.year"
                    :key="opt"
                    :label="opt"
                    :value="opt"
                  />
                </el-select>
                <base-button @click="handleFetchStats">Fetch Stats</base-button>
              </div>

            </div>
          </template>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <card>
          <template slot="header">
            <h3 class="card-title">Performance</h3>
          </template>
          <el-table :data="accountsStatsPerformance">
            <el-table-column
              label="Account Name"
              prop="name"
            />
            <el-table-column
              label="Revenue"
              prop="totalSoldRevenue"
            />
            <el-table-column
              label="Sold Qty"
              prop="totalSoldQuantity"
            />
            <el-table-column
              label="Commission Paid"
              prop="commissionPaid"
            />
            <el-table-column
              label="Shipping Paid"
              prop="shippingPaid"
            />
            <el-table-column
              label="Cost of Goods"
              prop="cogs"
            />
            <el-table-column
              label="Profit"
              prop="profit"
            />
            <el-table-column
              label="Avg Profit"
              prop="avgProfit"
            />
            <el-table-column
              label="Avg Daily Sold"
              prop="avgDailySold"
            />
          </el-table>
        </card>
      </div>

      <div class="col-lg-8 col-md-12">
        <card>
          <template slot="header">
            <h3 class="card-title">Buying</h3>
          </template>
          <el-table :data="accountsStatsBuying">
            <el-table-column
              label="Account Name"
              prop="name"
            />
            <el-table-column
              label="Cost"
              prop="cost"
            />
            <el-table-column
              label="Quantity"
              prop="quantity"
            />
            <el-table-column
              label="Avg Cost"
              prop="average"
            />
          </el-table>
        </card>
      </div>
      <div class="col-lg-4 col-md-12">
        <card>
          <template slot="header">
            <h3 class="card-title">Expenses</h3>
          </template>
          <h4>Total Expense: {{expenses.totalExpense || ''}}</h4>
          <h4>Tax Deductible Expense: {{expenses.taxDeductibleExpense || ''}}</h4>
        </card>
      </div>
    </div>

  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { Table, TableColumn, Select, Option, DatePicker } from 'element-ui'

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      dateOptions: {
        month: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        year: ['2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029'],
      },
      dateSelection: {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
      },
    }
  },
  created() {
    this.fetchEbayAccounts({ route: this.$router.currentRoute.path })
  },
  computed: {
    ...mapGetters('aggregation', ['aggregation', 'inventoryAggregation']),
    expenses() {
      return (this.aggregation && this.aggregation.expenses) || {}
    },
    accountsStatsPerformance() {
      if (this.aggregation && this.aggregation.accountsStats) {
        const performanceStats = []
        const accounts = Object.keys(this.aggregation.accountsStats)
        let totalRevenue = 0
        let totalQty = 0
        let totalCommission = 0
        let totalShipping = 0
        let totalCogs = 0
        let totalProfit = 0
        for (let i = 0; i < accounts.length; i++) {
          const {
            transactionsAggregation: {
              totalSoldRevenue,
              totalSoldQuantity,
              commissionPaid,
              shippingPaid,
              totalCostOfGoodsSold,
            },
          } = this.aggregation.accountsStats[accounts[i]]
          const profit = (totalSoldRevenue - commissionPaid - shippingPaid - totalCostOfGoodsSold).toFixed(2)
          const avgProfit = (profit / totalSoldQuantity).toFixed(2)
          const avgDailySold = parseFloat((totalSoldQuantity / this.daysInMonth).toFixed(2))
          performanceStats.push({
            name: accounts[i],
            totalSoldRevenue: totalSoldRevenue || 0,
            totalSoldQuantity: totalSoldQuantity || 0,
            commissionPaid: commissionPaid.toFixed(2) || 0,
            shippingPaid: shippingPaid || 0,
            cogs: totalCostOfGoodsSold || 0,
            profit: profit || 0,
            avgProfit: avgProfit || 0,
            avgDailySold: avgDailySold || 0,
          })
          totalRevenue += totalSoldRevenue || 0
          totalQty += totalSoldQuantity || 0
          totalCommission += commissionPaid || 0
          totalShipping += shippingPaid || 0
          totalCogs += totalCostOfGoodsSold || 0
          totalProfit += profit || 0
        }
        performanceStats.push({
          name: 'Total',
          totalSoldRevenue: totalRevenue,
          totalSoldQuantity: totalQty,
          commissionPaid: totalCommission.toFixed(2),
          shippingPaid: totalShipping,
          cogs: totalCogs,
          profit: totalProfit,
          avgProfit: (totalProfit / totalQty).toFixed(2),
          avgDailySold: (totalQty / this.daysInMonth).toFixed(2),
        })
        return performanceStats
      }
      return []
    },
    accountsStatsBuying() {
      if (this.aggregation && this.aggregation.accountsStats) {
        const buyingStats = []
        const accounts = Object.keys(this.aggregation.accountsStats)
        let totalCost = 0
        let totalQty = 0
        for (let i = 0; i < accounts.length; i++) {
          const {
            pendingAggregation: { totalCost: cost, totalQuantity: qty },
          } = this.aggregation.accountsStats[accounts[i]]
          buyingStats.push({
            name: accounts[i],
            cost: cost || 0,
            quantity: qty || 0,
            average: (cost / qty).toFixed(2) || 0,
          })
          totalCost += cost || 0
          totalQty += qty || 0
        }
        buyingStats.push({
          name: 'Total',
          cost: totalCost,
          quantity: totalQty,
          average: (totalCost / totalQty).toFixed(2),
        })
        return buyingStats
      }
      return []
    },
    daysInMonth() {
      const { month, year } = this.dateSelection
      const today = new Date()
      const currentDay = today.getDate()
      const currentMonth = today.getMonth() + 1
      const currentYear = today.getFullYear()

      if (year == currentYear) if (month == currentMonth) return currentDay
      if (month == 2) return year % 4 ? 28 : 29
      return +month % 2 ? 31 : 30
    },
  },
  methods: {
    ...mapActions('aggregation', ['fetchAggregation', 'fetchInventoryAggregation']),
    ...mapActions('settings', ['fetchEbayAccounts']),
    async handleFetchStats() {
      const result = await this.fetchAggregation(this.dateSelection)
      await this.fetchInventoryAggregation()
      console.log('result :', result)
    },
  },
}
</script>
<style></style>
